import * as PIXI from "pixi.js";
import {config} from "../../config";

export class WinField extends PIXI.Container {

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);
    private readonly BACKGROUND_WIDTH = 74;
    private readonly VALUE_POSITION = new PIXI.Point(0, 37);
    private readonly VALUE_TEXT_STYLE: any = {
        fontSize: 20,
        fill: "#fff",
        fontFamily: "RobotoCondensedRegular",
    };
    private readonly TITLE_TEXT_STYLE: any = {
        fontSize: 17,
        fill: "#c8c7c7",
        fontFamily: "RobotoCondensedRegular",
        fontWeight: 600,
        letterSpacing: 1.6,
    };
    private winText: PIXI.Text;
    private winValue: PIXI.Text;

    constructor() {
        super();
        this.createAndAddWinValueText();
        this.createAndAddWinTitle();
    }

    public updateWinValue(amount: number): void {
        if (amount !== 0) {
            this.winValue.text = "" + amount.toFixed(config.betDisplayPrecision);
        } else {
            this.winValue.text = "";
        }
    }

    public getWinValue(): number {
        return Number(this.winValue.text);
    }

    private createAndAddWinTitle(): void {
        this.winText = new PIXI.Text("WIN", this.TITLE_TEXT_STYLE);
        this.winText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.winText);
    }

    private createAndAddWinValueText(): void {
        this.winValue = new PIXI.Text("", this.VALUE_TEXT_STYLE);
        this.winValue.anchor = this.DEFAULT_ANCHOR_POINT;
        this.winValue.position = this.VALUE_POSITION;
        this.addChild(this.winValue);
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/WinField.ts